import { useQuery } from 'react-query'
import { projetoService } from '../services/projeto'
import { ProjetoFilters, ProjetoFormData } from '../tipos/projeto'
import { useToast } from '../../../contexts/NotificationContext'
import { useGlobalLoading } from '../../../contexts/LoadingContext'
import { useMutationWithToast } from '../../../hooks/useMutationWithToast'
import { extractErrorMessage } from '../../../utils/formatUtils'
import {
  useTiposProjeto,
  useStatusProjeto,
  usePrioridades,
  useSolicitantes,
  useAnalistasSMN,
  useAnalistasDDP,
  useDesenvolvedores
} from '../../../hooks/useDomainData'

export function useProjetos(filters?: ProjetoFilters) {
  const toast = useToast()
  const { stopLoading } = useGlobalLoading()
  
  return useQuery(
    ['projetos', filters],
    () => projetoService.buscarProjetos(filters || {}),
    {
      keepPreviousData: true,
      onSuccess: () => stopLoading(),
      onError: (error: any) => {
        stopLoading()
        toast.error(extractErrorMessage(error, 'Erro ao carregar projetos'))
      },
    }
  )
}

export function useProjeto(id: string) {
  const toast = useToast()
  
  return useQuery(
    ['projeto', id],
    () => projetoService.getProjetoById(id),
    {
      enabled: !!id,
      onError: (error: any) => {
        toast.error(extractErrorMessage(error, 'Erro ao carregar projeto'))
      },
    }
  )
}

export function useCreateProjeto() {
  return useMutationWithToast({
    mutationFn: projetoService.criarProjeto,
    successMessage: 'Projeto criado com sucesso!',
    errorMessage: 'Erro ao criar projeto',
    invalidateQueries: ['projetos', 'projeto'],
  })
}

export function useUpdateProjeto() {
  return useMutationWithToast({
    mutationFn: ({ id, data }: { id: string; data: ProjetoFormData }) =>
      projetoService.atualizarProjeto(id, data),
    successMessage: 'Projeto atualizado com sucesso!',
    errorMessage: 'Erro ao atualizar projeto',
    invalidateQueries: ['projetos', 'projeto'],
  })
}

export function useDeleteProjeto() {
  return useMutationWithToast({
    mutationFn: projetoService.excluirProjeto,
    successMessage: 'Projeto excluído com sucesso!',
    errorMessage: 'Erro ao excluir projeto',
    invalidateQueries: ['projetos'],
  })
}

// Re-exportar hooks de dados de domínio
export {
  useTiposProjeto,
  useStatusProjeto,
  usePrioridades,
  useSolicitantes,
  useAnalistasSMN,
  useAnalistasDDP,
  useDesenvolvedores
}
